import { render } from "./AddElementaryRoomsDataTable.vue?vue&type=template&id=2a7a34cc"
import script from "./AddElementaryRoomsDataTable.vue?vue&type=script&lang=js"
export * from "./AddElementaryRoomsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__